// src/pages/gears/Neo.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ IMPORT ONLY THE IMAGES YOU NEED
import droneImg from "./gearimages/gp8.jpg";

export default function GoPro8() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          {/* ⭐ NEW GEAR LAYOUT */}
          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>GoPro Hero 8 Black</h1>

              <p>
                The GoPro Hero 8 Black is a compact, rugged action camera known for its excellent 
                stabilization and reliable performance in almost any environment. It’s a favorite 
                among travelers, vloggers, and adventure creators thanks to its smooth footage, 
                simple controls, and durable waterproof design.
              </p>

              <p>
                With HyperSmooth 2.0 stabilization, improved low‑light performance, and built‑in 
                mounting fingers, the Hero 8 remains one of the most versatile GoPro models ever 
                released. Whether you're hiking, biking, snorkeling, or capturing everyday moments, 
                the Hero 8 delivers sharp video and vibrant colors straight out of the camera.
              </p>

              <div className="place-block">
                <ul>
                  <li>4K video at 60fps + 1080p at 240fps</li>
                  <li>HyperSmooth 2.0 stabilization (all resolutions)</li>
                  <li>TimeWarp 2.0 hyperlapse mode</li>
                  <li>12MP photos with improved HDR</li>
                  <li>Waterproof up to 10m (33 ft) without a case</li>
                  <li>Built‑in folding mounting fingers</li>
                  <li>LiveBurst mode (1.5 seconds before/after shutter)</li>
                  <li>Night Lapse video + improved low‑light performance</li>
                  <li>Up to ~70–80 minutes of recording per charge (varies by mode)</li>
                </ul>
              </div>

              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/4ehofX6"
              />

              <AffiliateEbay
              title="Check price on eBay"
                link="https://ebay.us/TyKw4S"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={droneImg} alt="GoPro Hero 8 Black" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
